<template>
    <vuestic-widget header-text="Proveedores">
        <div class="form-group">
            <div class="input-group">
                <label for="filtro">Filtro Nombre</label>
                <input type="text" id="filtro" v-model="filtro">
                <i class="bar"></i>
            </div>
        </div>
        <table class="table table-bordered table-striped">
            <thead class="thead-light">
            <tr>
                <th>Razón Social</th>
                <th>Rut</th>
                <th>Télefono</th>
                <th>Email</th>
                <th>Opciones</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="proveedor in proveedores">
                <td>{{proveedor.nombre | upper}}</td>
                <td>{{proveedor.rut}}</td>
                <td>{{proveedor.telefono}}</td>
                <td>{{proveedor.email}}</td>
                <td><i class="fa fa-eye" @click="verProveedor(proveedor)"></i></td>
            </tr>
            </tbody>
        </table>
    </vuestic-widget>
</template>
<script>
    import VuesticWidget from "../../../vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget";
    export default {
        name: 'listaProveedores',
        components: {VuesticWidget},
        created() {
            this.$store.dispatch('loadProveedores')
        },
        methods: {
            verProveedor(proveedor) {
                this.$router.push({path: '/finanzas/proveedores/estado-cuenta', query: {id: proveedor.id, nombre: proveedor.nombre}})
            }
        },
        computed: {
            proveedores(){
                const proveedores = this.$store.getters.proveedores
                if(this.filtro !== "") {
                    return proveedores.filter(p => p.nombre.toLowerCase().includes(this.filtro))
                }
                else
                    return proveedores
            }
        },
        data() {
            return {
                filtro: ""
            }
        },
        filters:{
            upper(text){
                if(text){
                    return text.toUpperCase()
                }else {
                    return text
                }

            }
        }
    }
</script>
